/**
 * The `/posts/$postId` param as a number, or `null` when it cannot name a post, so the screen
 * renders its not-found state without a request (docs/route-loading.md, "Not-found answers").
 *
 * Digits only, no leading zero, the way `screens/courses/lib/params.ts`'s `parseId` reads mm-be's
 * `<int:…>` converters: `Number()` would read "1e3" as 1000 and turn a URL that names nothing into
 * a request for a real post. Its own `lib/` module because the loader needs it too, and a loader
 * must never import a component module.
 */
export const parsePostId = (raw: string): number | null => {
  if (!/^[1-9]\d*$/.test(raw)) return null
  const value = Number(raw)
  return Number.isSafeInteger(value) ? value : null
}
